module.exports = __webpack_public_path__ + "img/cover2025.e58c9a07.png";